export const IS_PRODUCTION = process.env.VITE_APP_ENV_NAME === 'PROD'
export const AMIL_CLINIC_IDS = [8678, 8867]
export const CAAPR_CLINIC_IDS = [8855, 8386]
